import firstShop_1x from 'images/Recipe/PresentImg/mob/firstShop_1x.webp';
import firstShop_2x from 'images/Recipe/PresentImg/mob/firstShop_2x.webp';
import tab_firstShop_1x from 'images/Recipe/PresentImg/tablet/firstShop_1x.webp';
import tab_firstShop_2x from 'images/Recipe/PresentImg/tablet/firstShop_2x.webp';
import desct_firstShop_1x from 'images/Recipe/PresentImg/desctop/firstShop_1x.webp';
import desct_firstShop_2x from 'images/Recipe/PresentImg/desctop/firstShop_2x.webp';

import tenRecipe_1x from 'images/Recipe/PresentImg/mob/10recipe_1x.webp';
import tenRecipe_2x from 'images/Recipe/PresentImg/mob/10recipe_2x.webp';
import tab_tenRecipe_1x from 'images/Recipe/PresentImg/tablet/10recipe_1x.webp';
import tab_tenRecipe_2x from 'images/Recipe/PresentImg/tablet/10recipe_2x.webp';
import desct_tenRecipe_1x from 'images/Recipe/PresentImg/desctop/10recipe_1x.webp';
import desct_tenRecipe_2x from 'images/Recipe/PresentImg/desctop/10recipe_2x.webp';

import firstRecipe_1x from 'images/Recipe/PresentImg/mob/favorite_1x.webp';
import firstRecipe_2x from 'images/Recipe/PresentImg/mob/favorite_2x.webp';
import tab_firstRecipe_1x from 'images/Recipe/PresentImg/tablet/favorite_1x.webp';
import tab_firstRecipe_2x from 'images/Recipe/PresentImg/tablet/favorite_2x.webp';
import desct_firstRecipe_1x from 'images/Recipe/PresentImg/desctop/favorite_1x.webp';
import desct_firstRecipe_2x from 'images/Recipe/PresentImg/desctop/favorite_2x.webp';

import oneHundredDay_1x from 'images/Recipe/PresentImg/mob/100day_1x.webp';
import oneHundredDay_2x from 'images/Recipe/PresentImg/mob/100day_2x.webp';
import tab_oneHundredDay_1x from 'images/Recipe/PresentImg/tablet/100day_1x.webp';
import tab_oneHundredDay_2x from 'images/Recipe/PresentImg/tablet/100day_2x.webp';
import desct_oneHundredDay_1x from 'images/Recipe/PresentImg/desctop/100day_1x.webp';
import desct_oneHundredDay_2x from 'images/Recipe/PresentImg/desctop/100day_2x.webp';

export const imgModal = {
  firstShopping: {
    mob_1x: firstShop_1x,
    mob_2x: firstShop_2x,
    tab_1x: tab_firstShop_1x,
    tab_2x: tab_firstShop_2x,
    des_1x: desct_firstShop_1x,
    des_2x: desct_firstShop_2x,
  },
  tenRecipes: {
    mob_1x: tenRecipe_1x,
    mob_2x: tenRecipe_2x,
    tab_1x: tab_tenRecipe_1x,
    tab_2x: tab_tenRecipe_2x,
    des_1x: desct_tenRecipe_1x,
    des_2x: desct_tenRecipe_2x,
  },
  firstRecipes: {
    mob_1x: firstRecipe_1x,
    mob_2x: firstRecipe_2x,
    tab_1x: tab_firstRecipe_1x,
    tab_2x: tab_firstRecipe_2x,
    des_1x: desct_firstRecipe_1x,
    des_2x: desct_firstRecipe_2x,
  },
  oneHundredDay: {
    mob_1x: oneHundredDay_1x,
    mob_2x: oneHundredDay_2x,
    tab_1x: tab_oneHundredDay_1x,
    tab_2x: tab_oneHundredDay_2x,
    des_1x: desct_oneHundredDay_1x,
    des_2x: desct_oneHundredDay_2x,
  },
};
